import { Input } from "reactstrap";
import {
  PaymentStatus,
  paymentStatusMap,
} from "features/Payments/constants/payment.constants";

type Props = {
  status: string;
  onStatusChange: (value: string) => void;
};

export default function PaymentListFilters({ status, onStatusChange }: Props) {
  return (
    <div className="d-flex align-items-center gap-2">
      <Input
        type="select"
        className="form-select"
        style={{ width: 180 }}
        value={status}
        onChange={(e) => onStatusChange(e.target.value)}
      >
        <option value="">All statuses</option>
        {(Object.values(PaymentStatus) as PaymentStatus[]).map((s) => (
          <option key={s} value={s}>
            {paymentStatusMap[s]?.label ?? s}
          </option>
        ))}
      </Input>
    </div>
  );
}
